import React, { useEffect } from "react";
import { useLocation, } from "react-router-dom";
import endPoints from "../../api/endPoints";
import { postCall } from "../../api/request";
import SplashScreen from "../../components/splashScreen";

export default function VerifyTransaction() {
  const { search } = useLocation();
  useEffect(() => {
    const object = new URLSearchParams(search);
    (async () => {
      try {
        let { data:{message} } = await postCall(endPoints.verifyCard, {
          reference: object.get("reference"),
        });
        if(message === "Payment Successful"){
            window.location = "/app/transactions"
        }
      } catch (error) {}
    })();
  }, []);
  return (
    <div>
      <SplashScreen />
    </div>
  );
}
